import { render, staticRenderFns } from "./FaceVerifyPopu.vue?vue&type=template&id=8eed31cc&scoped=true"
import script from "./FaceVerifyPopu.vue?vue&type=script&lang=js"
export * from "./FaceVerifyPopu.vue?vue&type=script&lang=js"
import style0 from "./FaceVerifyPopu.vue?vue&type=style&index=0&id=8eed31cc&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eed31cc",
  null
  
)

export default component.exports